import React, { useState, useEffect } from "react";

const AdminDashboard = () => {
  const [whatsapp, setWhatsapp] = useState("");
  const [call, setCall] = useState("");
  const [ageEnabled, setAgeEnabled] = useState(true);

  useEffect(() => {
    // 📞 Numbers
    const savedWhatsapp = localStorage.getItem("whatsappNumber");
    const savedCall = localStorage.getItem("callNumber");

    if (savedWhatsapp) setWhatsapp(savedWhatsapp);
    if (savedCall) setCall(savedCall);

    // 🔞 Age Verification Status
    const ageStatus = localStorage.getItem("ageVerificationEnabled");
    if (ageStatus === "false") {
      setAgeEnabled(false);
    }
  }, []);

  // 💾 Save Call & WhatsApp
  const saveNumbers = () => {
    localStorage.setItem("whatsappNumber", whatsapp);
    localStorage.setItem("callNumber", call);
    alert("✅ WhatsApp & Call numbers updated successfully");
  };

  // 🔞 Toggle Age Verification
  const toggleAgeVerification = () => {
    const newStatus = !ageEnabled;
    setAgeEnabled(newStatus);
    localStorage.setItem(
      "ageVerificationEnabled",
      newStatus ? "true" : "false"
    );

    alert(
      newStatus
        ? "🔞 Age Verification ENABLED"
        : "🚫 Age Verification DISABLED"
    );
  };

  return (
    <div style={{ padding: "30px", maxWidth: "500px" }}>
      <h1>Admin Dashboard 👑</h1>

      {/* 🔞 AGE VERIFICATION CONTROL */}
      <div
        style={{
          marginTop: "30px",
          padding: "20px",
          border: "1px solid #ddd",
          borderRadius: "8px",
        }}
      >
        <h3>🔞 Age Verification Popup</h3>

        <p>
          Status:{" "}
          <strong style={{ color: ageEnabled ? "green" : "red" }}>
            {ageEnabled ? "ON" : "OFF"}
          </strong>
        </p>

        <button
          onClick={toggleAgeVerification}
          style={{
            padding: "10px",
            width: "100%",
            background: ageEnabled ? "#A61325" : "#333",
            color: "#fff",
            border: "none",
            cursor: "pointer",
            fontSize: "15px",
            marginTop: "10px",
          }}
        >
          {ageEnabled ? "Disable Age Verification" : "Enable Age Verification"}
        </button>
      </div>

      {/* 📞 FLOATING BUTTON NUMBERS */}
      <div style={{ marginTop: "35px" }}>
        <h3>🟢 WhatsApp Floating Button</h3>
        <input
          type="text"
          placeholder="Enter WhatsApp Number (ex: 919876543210)"
          value={whatsapp}
          onChange={(e) => setWhatsapp(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "15px",
          }}
        />

        <h3>📞 Call Floating Button</h3>
        <input
          type="text"
          placeholder="Enter Call Number (ex: 919876543210)"
          value={call}
          onChange={(e) => setCall(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "20px",
          }}
        />

        <button
          onClick={saveNumbers}
          style={{
            padding: "12px",
            width: "100%",
            background: "#8E1624",
            color: "#fff",
            border: "none",
            cursor: "pointer",
            fontSize: "16px",
          }}
        >
          Save Numbers
        </button>
      </div>
    </div>
  );
};

export default AdminDashboard;
